import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import ArticleVideo from './articleVideo';
import ArticleText from './articleText';
import ArticleImg from './articleImg';
import ArticleGif from './articleGif';
import Photoswiper from '../../../components/photoswipe';

class PicText extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    state = {
        photoShow: false,
        photoCurrent: 0,
        photoActiveImageIndex: 0,
        isRunPhotoswiper: true,
    };

    componentDidMount() {
        this.manyVideoPlay();
        window.addEventListener('scroll', this.handleScroll);

        if (!(window.self === window.top)) {
            this.setState({
                isRunPhotoswiper: false,
            });

            window.addEventListener(
                'message',
                event => {
                    if (event.data.title === 'picture-active-index') {
                        this.setState({
                            photoActiveImageIndex: event.data.index,
                        });
                    }
                },
                false,
            );
        }
    }

    interval = null;
    scrollTopValue = 0;
    pArrays = [];
    imageIndex = -1;

    manyVideoPlay = () => {
        const allVideo = document.querySelectorAll('video');

        for (let i = 0; i < allVideo.length; i++) {
            (index => {
                allVideo[index].addEventListener(
                    'play',
                    () => {
                        allVideo[index].play();

                        for (let j = 0; j < allVideo.length; j++) {
                            if (j === index) continue;
                            allVideo[j].pause();
                        }
                    },
                    false,
                );
            })(i);
        }
    };

    handleScroll = () => {
        const { content } = this.props;
        const node = document.querySelector('#contentBox').getElementsByTagName('p');

        if (this.interval == null) {
            this.interval = setInterval(() => {
                if (document.documentElement.scrollTop === this.scrollTopValue) {
                    try {
                        window.JSAPI.readCompletion(
                            content.base62Id,
                            parseInt((this.pArrays.length / node.length) * 100),
                        );
                    } catch (e) {
                        // console.log(e);
                    }
                    clearInterval(this.interval);
                    this.interval = null;
                }
            }, 1000);
        }
        this.scrollTopValue = document.documentElement.scrollTop;
        for (let i = 0; i < node.length; i++) {
            this.elementVisible(node[i], i);
        }
    };

    elementVisible = (ele, index) => {
        let sTop =
            document.documentElement.scrollTop === 0 ? document.body.scrollTop : document.documentElement.scrollTop;

        if (document.compatMode === 'BackCompat') {
            sTop = document.body.scrollTop;
        }

        const bottomNum = ele.offsetTop - window.screen.availHeight;
        const top = ele.offsetTop;

        if (bottomNum < sTop && sTop < top) {
            if (this.pArrays.length === 0) {
                this.pArrays.push(index);
            }
            if (!this.in_array(index, this.pArrays)) {
                this.pArrays.push(index);
            }
        }
    };

    in_array = (search, array) => {
        for (const i in array) {
            if (array[i] === search) {
                return true;
            }
        }

        return false;
    };

    getImgCurrentIndex = url => {
        const { content } = this.props;
        const { imagesInContent } = content;
        const urlKey = url.split('/')[url.split('/').length - 1].split('_')[0];

        for (let i = 0; i < imagesInContent.length; i++) {
            if (imagesInContent[i].url.includes(urlKey)) {
                this.setState({
                    photoCurrent: i,
                    photoShow: true,
                    photoActiveImageIndex: i,
                });
            }
        }
    };

    getcontent = (item, index) => {
        const { photoShow, photoActiveImageIndex } = this.state;

        if (index === 0) {
            this.imageIndex = -1;
        }

        if (item.type === 'text') {
            return <ArticleText key={index} content={item.data} />;
        }

        if (item.type === 'video') {
            return <ArticleVideo key={index} content={item.data} isPhotoShow={photoShow} />;
        }

        if (item.type === 'gif') {
            this.imageIndex++;

            return (
                <ArticleGif
                    key={index}
                    content={item}
                    imageIndex={this.imageIndex}
                    photoActiveImageIndex={photoActiveImageIndex}
                    getImgCurrentIndex={this.getImgCurrentIndex}
                />
            );
        }

        if (item.type === 'image') {
            this.imageIndex++;

            return <ArticleImg key={index} content={item} getImgCurrentIndex={this.getImgCurrentIndex} />;
        }

        return null;
    };

    handlePhotoClose = () => {
        this.setState({
            photoShow: false,
        });
    };

    imgageIndexChangeHandle = imageIndex => {
        const { isRunPhotoswiper } = this.state;

        if (isRunPhotoswiper) {
            this.setState({
                photoActiveImageIndex: imageIndex,
            });
        }
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { photoShow, photoCurrent, isRunPhotoswiper } = this.state;
        const year = content.newsTime && content.newsTime.split(' ')[0];
        const time = content.newsTime && content.newsTime.split(' ')[1];

        return (
            <div className={styles.content}>
                {isRunPhotoswiper && (
                    <NoSSR>
                        <Photoswiper
                            content={content.imagesInContent}
                            galleryShow={photoShow}
                            galleryCurrent={photoCurrent}
                            handleGalleryClose={this.handlePhotoClose}
                            isShowPageName={true}
                            imgageIndexChangeHandle={this.imgageIndexChangeHandle}
                            isHistory={true}
                        />
                    </NoSSR>
                )}
                <h1>{content.title}</h1>
                <div className={styles.source}>
                    <span className={styles.fromSource}>{content.source}</span>
                    <span>
                        <i className={styles.sourceyear}>{year}</i>
                        <i className={styles.sourcetime}>{time}</i>
                    </span>
                </div>
                <div className={styles.acTx} id="contentBox">
                    {content.contentData.contentList.map((item, index) => this.getcontent(item, index))}
                </div>
                {/* <div className={styles.author}>
                    <div className={styles.authorName}>内容来自凤凰新闻</div>
                </div> */}
                {/* <div
                    style={{ width: '50px', height: '50px', background: 'red', position: 'fixed', right: '10px', bottom: '50px' }}
                    onClick={() => {
                        location.reload();
                    }} /> */}
            </div>
        );
    }
}

export default errorBoundary(PicText);
